import { useQuery } from "react-query";
import { Pageable } from "../../services/pageable";
import { useDefaultQueryOptions } from "../client-query";
import { ParticipationsDTO } from "./models/dto";
import {
  ALL_CONFIGURATIONS,
  ALL_PARTICIPATIONS,
  PARTICIPATION_SUMMARY,
  SINGLE_PARTICIPATION,
} from "./resources";
import { ParticipationsService } from "./service";

export const useAllParticipations = (
  pagination: Pageable.T<
    Exclude<keyof ParticipationsDTO.Responses.GetSingle.T, "editable">
  >
) =>
  useQuery(
    [ALL_PARTICIPATIONS, pagination],
    () => ParticipationsService.getParticipations(pagination),
    useDefaultQueryOptions()
  );

export const useParticipation = (id: string) =>
  useQuery(
    [SINGLE_PARTICIPATION, id],
    () => ParticipationsService.getParticipation(id),
    useDefaultQueryOptions()
  );

export const useAllConfigurations = () =>
  useQuery(
    [ALL_CONFIGURATIONS],
    () =>
      ParticipationsService.getConfigurations({
        pagination: {
          size: 20,
          page: 0,
        },
      }),
    useDefaultQueryOptions()
  );

export const usePariticipationSummary = () =>
  useQuery(
    [PARTICIPATION_SUMMARY],
    () => ParticipationsService.getParticipationSummary(),
    useDefaultQueryOptions()
  );
